module.exports = __webpack_public_path__ + "static/img/logo-green.8dd9cc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-green.png
// module id = PV16
// module chunks = 3